import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, catchError, map } from 'rxjs';
import { DataTablesResponse } from '../models/datatables';
import { LeapmotorMktCoopAnimationDTO, LeapmotorMktCoopDistributorBudgetDTO, MktCoopDistributorBudgetPost } from '../models/mkt-coop-animation';


@Injectable({
  providedIn: 'root'
})

export class MktCoopAnimationService {

  private pathAPI = environment.urlAPI;
  private controller = "LeapmotorMktCoopAnimation/";

  public userData = new BehaviorSubject<LeapmotorMktCoopAnimationDTO>(null);

  constructor(private http: HttpClient) { }


  public get(id: string): Observable<LeapmotorMktCoopAnimationDTO> {
    return this.http.get<LeapmotorMktCoopAnimationDTO>(this.pathAPI + this.controller + id);
  }

  public post(data: LeapmotorMktCoopAnimationDTO): Observable<any> {
    return this.http.post<any>(this.pathAPI + this.controller, data);
  }

  public put(id: string, data: LeapmotorMktCoopAnimationDTO): Observable<any> {
    return this.http.put<any>(this.pathAPI + this.controller + id, data);
  }

  public changeStatus(id: string, idStatus: number): Observable<any> {
    return this.http.put<any>(this.pathAPI + this.controller + 'ChangeStatus/' + id + '/' + idStatus, null);
  }

  public getDataTable(data: any): Observable<DataTablesResponse> {
    return this.http.post<DataTablesResponse>(this.pathAPI + this.controller + 'GetDataTable/', data);
  }

  public LoadBudget(fileToUpload: File, idAnimation: string): Observable<any> {
    let formData: FormData = new FormData();
    formData.append('fileKey', fileToUpload, fileToUpload.name);
    return this.http.post<any>(this.pathAPI + this.controller + 'LoadBudget/' + idAnimation, formData);
  }

  DownloadExcelBudget(idAnimation: string): Observable<Blob> {
    let requestOptions: Object = {
      responseType: 'blob'
    }
    let endpoint = this.pathAPI + this.controller + 'GetAnimationBudgetExcel/' + idAnimation;
    return this.http.post<Blob>(endpoint, null, requestOptions);
  }

  public GetAnimationSelect(): Observable<any> {
    return this.http.get<any>(this.pathAPI + this.controller + 'GetAnimationSelect');
  }

  public SendAnimationBudgetLoadMail(idAnimation): Observable<any> {
    return this.http.post<any>(this.pathAPI + this.controller + 'SendAnimationBudgetLoadMail/' + idAnimation, null);
  }

  public GetCurrentAnimation(): Observable<LeapmotorMktCoopAnimationDTO> {
    return this.http.get<LeapmotorMktCoopAnimationDTO>(this.pathAPI + this.controller + 'GetCurrentAnimation');
  }

  public GetLastActiveAnimation(): Observable<LeapmotorMktCoopAnimationDTO> {
    return this.http.get<LeapmotorMktCoopAnimationDTO>(this.pathAPI + this.controller + 'GetLastActiveAnimation');
  }

  public GetDistributorBudgets(idAnimation: string, idDistributor: string): Observable<LeapmotorMktCoopDistributorBudgetDTO[]> {
    return this.http.get<LeapmotorMktCoopDistributorBudgetDTO[]>(this.pathAPI + this.controller + 'GetDistributorBudgets/' + idAnimation + '/' + idDistributor);
  }

  public SaveDistributorBudgets(idAnimation: string, idDistributor: string, data: MktCoopDistributorBudgetPost[]): Observable<any> {
    return this.http.put<any>(this.pathAPI + this.controller + 'SaveDistributorBudgets/' + idAnimation + '/' + idDistributor, data);
  }

}